const React = require('react');

const Component = require('./Component.jsx');
const ContentContainer = require('./ContentContainer.jsx');
const _TypeConfig = require('./TypeConfig.jsx');

function withItemContentDataHandler(WrappedComponent) {
    return class extends React.Component {
        constructor(props) {
            super(props);

            this.handleContentData = this.handleContentData.bind(this);
        }

        handleContentData() {
            const items = this.props.items || [];
            let contentData = [];
            if (items.length > 0) {
                if (this.props.builder) {
                    contentData.push(items[0]);
                } else {
                    contentData = items;
                }
            }
            return contentData;
        }

        render() {
            return <WrappedComponent {...this.props} onItemContentData={this.handleContentData} />
        }
    }
}

class _PageContainer extends React.Component {
    constructor(props) {
        super(props);

        this.containerForItem = this.containerForItem.bind(this);
    }

    containerForItem(pageIndex, itemIndex, componentData, pageHeader, insertPageBreak) {
        const ItemComponent = this.props.itemContentContainer || ContentContainer;
        const content = (
            <ItemComponent
                key={pageIndex}
                {...this.props}
                componentData={componentData}
                dataType='container' />
        );
        let pageClassName;
        if (insertPageBreak || (this.props.items && itemIndex < this.props.items.length - 1)) {
            pageClassName = 'pageBreakAfterAlways';
        }
        return this.props.onPageForItem(pageIndex, content, pageHeader, pageClassName);
    }

    render() {
        const contentData = this.props.onItemContentData();
        const pageHeader = this.props.onPageHeader();
        let content = [];
        if (this.props.onComponentContent) {
            content = this.props.onComponentContent(contentData, pageHeader, this.containerForItem);
        } else {
            contentData.forEach((d, i) => {
                content.push(this.containerForItem(i, i, [{ index: i, itemData: d }], pageHeader));
            });
        }
        return content;
    }
}
const PageContainer = Component.withBlockComponentHandler(Component.withPageHandler(withItemContentDataHandler(_PageContainer), true));

const TypeConfig = {
    panel: {
        block: (group, contentType, options = []) => {
            return {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Edit Item Content',
                        fullWidth: true,
                        group,
                        offsetTop: true,
                        type: 'edit-button',
                        value: {
                            keyPath: ['Block', 'design'],
                            name: contentType
                        }
                    },
                    ...options
                ]
            };
        },
        columns: () => [[]],
        style: () => _TypeConfig.panel.layoutStyleV2('block', undefined, {}, undefined, {})
    }
};

module.exports = {
    Page: PageContainer,
    TypeConfig
};